import React from 'react';
import { connect } from 'react-redux';
import { ContextualMenu, hideWhenClickAwayOrResize, showHideMenu } from '../../../shared/contextualMenu/content';
import { bindActionCreators } from 'redux';
import { redirectToInternalLink } from '../../../../businessLogic/redirector.js';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import GroupFormPage from '../../../../containers/GroupFormPage.js';
import MeetingRoomFormPage from '../../../../containers/MeetingRoomFormPage.js';
import { updateGroupSearch, updateGroupForm, clickedUpdateGroup } from '../../../../actions/group.js';
import { clone } from '../../../../reducers/helper.js';
import { updateMeetingRoomForm, updateMeetingRoomSearch } from '../../../../actions/meetingRoom.js';
import DeleteGroupPage from '../../../../containers/DeleteGroupPage.js';
import { showModal } from '../../../../actions/modal.js';

const permissionsEnum = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  JOIN_ROOM: 'JOIN_ROOM',
  MODERATE_CALLS: 'MODERATE_CALLS',
};

@connect(mapStateToProps)
export default class ViewAllGroupCenterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupsFiltered: props.groupsFiltered,
      groupsGray: props.groupsGray,
      groups: props.groups,
    };
  }
  getCurrentActiveItem = () => {
    return this._currentItem;
  };
  setCurrentActiveItem = (val) => {
    this._currentItem = val;
    return this._currentItem;
  };
  updateGroupSearchValue = (e) => {
    if (e.target != undefined) this.props.dispatch(updateGroupSearch(e.target.value));
    else this.props.dispatch(updateGroupSearch(e));
  };

  editGroup = (groupId) => {
    this.props.dispatch(updateGroupForm(this.state.groups.find((x) => x.id == groupId)));
    this.props.dispatch(clickedUpdateGroup());
    this.showUpdateGroupModal();
  };

  showGroupProperties = (groupId) => {
    var groupForm = this.props.groups.find((x) => x.id == groupId);
    this.props.dispatch(updateGroupForm(groupForm));
    window.$('.ui.modal.view-group').modal({ closable: false }).modal('show');
  };
  deleteGroup = (groupId) => {
    this.props.dispatch(updateGroupForm(this.props.groups.find((x) => x.id == groupId)));
    this.showDeleteModal();
  };
  showDeleteModal = () => {
    window.$('.ui.modal.delete-group').modal({ closable: false }).modal('show');
    window.$('.ui.modal.delete-group .field input').change();
    clearAllValidationErrors();
  };

  viewMeetingRoomsFromGroup = (groupName) => {
    redirectToInternalLink('/meeting-room/view-all');
    this.props.dispatch(updateMeetingRoomSearch('parentGroupName¤' + groupName));
  };
  createMeetingRoom = (groupId) => {
    var meetingRoomForm = clone(this.props.meetingRoomForm);
    meetingRoomForm.ParentGroupId = groupId;
    meetingRoomForm.name = '';
    meetingRoomForm.id = 0;
    var group = this.props.groups.find((x) => x.id == groupId);
    meetingRoomForm.parentGroupName = group.name;
    meetingRoomForm.headerName = group.name + ' (' + group.organisationName + ')';
    this.props.dispatch(updateMeetingRoomForm(meetingRoomForm));
    window.$('.ui.modal.insertFromGroup-meeting-room').modal({ closable: false }).modal('show');
    clearAllValidationErrors();
    //  this.props.dispatch(clickedUpdateMeetingRoom());
  };

  showUpdateGroupModal = () => {
    this.props.dispatch(showModal('.ui.modal.update-group'));
    // window.$(".ui.modal.update-group .field input").change();
    clearAllValidationErrors();
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.setState({
      groupsFiltered: props.groupsFiltered,
      groupsGray: props.groupsGray,
      groups: props.groups,
    });
  };

  componentDidMount = () => {
    window.$('body').click(hideWhenClickAwayOrResize.bind(this, '.group-view-all'));
    window.$(window).resize(hideWhenClickAwayOrResize.bind(this, '.group-view-all'));
  };
  componentWillUnmount = () => {
    window.$('body').unbind('click', hideWhenClickAwayOrResize.bind(this, '.group-view-all'));
  };

  mouseMovedOnTable = (e) => {
    let heightOfOneRow = 0;
    if (window.$(e.target).hasClass('right-column-fixed')) {
      heightOfOneRow = window.$(e.target).height();
    }
    this.mouseY = e.pageY - window.$(e.target).offset().top + heightOfOneRow;
  };

  render() {
    let groups = '';
    let groupsGray = '';
    let that = this;
    let renderGroups = (gray) => {
      let iterator = gray ? this.state.groupsGray : this.state.groupsFiltered;
      if (!iterator) {
        iterator = [];
      }
      return iterator.map((group, i) => {
        group.permissions = group.permissions || [];
        let contextualMenu = '';
        contextualMenu = (
          <ContextualMenu
            id={group.id}
            options={[
              {
                title: APP.LANGUAGE.ViewGroup.EditAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.EDIT) > -1,
                action: () => that.editGroup(group.id),
              },
              {
                title: APP.LANGUAGE.ViewGroup.ViewAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show:
                  group.permissions.indexOf(APP.LANGUAGE.Group_Permission.VIEW) > -1 &&
                  group.permissions.indexOf(APP.LANGUAGE.Group_Permission.EDIT) < 0,
                action: () => that.showGroupProperties(group.id),
              },
              {
                title: APP.LANGUAGE.ViewGroup.EmailAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.VIEW_MEMBERS) > -1,
                action: () => {},
              },
              {
                title: APP.LANGUAGE.ViewGroup.ManageUserAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.MANAGE_USERS) > -1,
                action: () => {},
              },
              {
                title: APP.LANGUAGE.ViewGroup.ViewUserAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show:
                  group.permissions.indexOf(APP.LANGUAGE.Group_Permission.VIEW_MEMBERS) > -1 &&
                  group.permissions.indexOf(APP.LANGUAGE.Group_Permission.MANAGE_USERS) < 0,
                action: () => {},
              },
              {
                title: APP.LANGUAGE.ViewGroup.ViewMeetingRoomAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.VIEW_MEETING_ROOM) > -1,
                action: () => that.viewMeetingRoomsFromGroup(group.name),
              },
              {
                title: APP.LANGUAGE.ViewGroup.CreateMeetingRoomAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.CREATE_MEETING_ROOM) > -1,
                action: () => that.createMeetingRoom(group.id),
              },
              {
                title: APP.LANGUAGE.ViewGroup.DeleteAction,
                customAction: true,
                openInModal: true,
                isFetching: false,
                show: group.permissions.indexOf(APP.LANGUAGE.Group_Permission.DELETE) > -1,
                action: () => that.deleteGroup(group.id),
              },
            ]}
          />
        );

        return (
          <div
            className="row flexible row-hoverable "
            data-opaque={!!gray}
            key={group.id}
            onClick={(event) => showHideMenu(this, '.group-view-all', group.id, event.target)}
          >
            {contextualMenu}
            <div className="left-column-fixed left-text first-column column bold ">{group.name}</div>
            <div className="right-column-fixed left-text second-column column ">{group.orgAbbreviatedName}</div>
            <div className="right-column-fixed left-text third-column column ">{group.membersCount}</div>
          </div>
        );
      });
    };

    if (!this.props.isFetchingGroup || this.state.groupsFiltered.length > 0 || this.state.groupsGray.length > 0) {
      groups = renderGroups(false);
      groupsGray = renderGroups(true);
    } else if (this.props.isFetchingGroup) {
      //if we are fetching meeting rooms, then render this placeholder
      groups = [0, 1].map((o, i) => {
        //this allows us to return 2 divs without a wrapper
        if (o == 1) {
          return (
            <div key={i} className="row flexible row-hoverable row-loading ">
              <div className="left-column-fixed first-column left-text column bold  pdnull  pdtnull  pdrs">
                <span className="color-gray color-gray-bg">asdasdasdasdasdasdasdasdasdasdasdas</span>
              </div>
              <div className="right-column-fixed left-text column   pdnull  pdtnull  second-column pdrs">
                <span className="color-gray  color-gray-bg">asdasdasdasd</span>
              </div>
              <div className="right-column-fixed third-column left-text column   pdnull  pdtnull pdrs">
                <span className="color-gray  color-gray-bg">asdasdasdasd</span>
              </div>
              <div className="ui active inverted dimmer " />
            </div>
          );
        } else {
          return (
            <div key={i} className="row flexible row-hoverable row-loading ">
              <div className="left-column-fixed first-column left-text column bold  pdnull  pdtnull  ">
                <span className="color-gray  color-gray-bg">asdasdasdasdasdasdasdasdasdasdasdas</span>
              </div>
              <div className="right-column-fixed left-text column   pdnull  pdtnull  second-column">
                <span className="color-gray  color-gray-bg">asdasdasdasd</span>
              </div>
              <div className="right-column-fixed third-column left-text column   pdnull   pdtnull ">
                <span className="color-gray  color-gray-bg">asdasdasdasd</span>
              </div>
              <div className="ui active inverted dimmer">
                <div className="ui text loader mrtl " />
              </div>
            </div>
          );
        }
      });
    }

    let modals = '';

    modals = (
      <span>
        <GroupFormPage updateOrInsert="insert" />
        <GroupFormPage updateOrInsert="update" />
        <GroupFormPage updateOrInsert="view" />
        <DeleteGroupPage />
        <MeetingRoomFormPage updateOrInsert="insertFromGroup" />
      </span>
    );

    let textInputToDisplay = '';

    if (this.props.currentGroupFilter.indexOf('¤') > -1) {
      let valueToDisplay = this.props.currentGroupFilter.split('¤')[1];
      textInputToDisplay = (
        <div className="ui transparent icon input color-white color-groups-bg-highlight pdls center-flex">
          <div className="ui image label mrrxl hide-on-small-ress mrrxl">
            {valueToDisplay.length > 10 ? valueToDisplay.substring(0, 10) + '...' : valueToDisplay}
            <i
              onClick={() => {
                this.updateGroupSearchValue('');
              }}
              className="delete icon"
            />
          </div>
          <button className="ui icon button show-on-small-ress mrrxl ">
            <i
              className="delete icon"
              onClick={() => {
                this.updateGroupSearchValue('');
              }}
            />
          </button>
          <i className="search link icon mrrs" />
        </div>
      );
    } else {
      textInputToDisplay = (
        <div className="ui transparent icon input color-white color-groups-bg-highlight pdls center-flex">
          <textarea
            type="text"
            className="color-white   color-groups-bg-highlight pdtxs hide-on-small-ress"
            onChange={this.updateGroupSearchValue}
            value={this.props.currentMeetingRoomNameFilter}
            placeholder={APP.LANGUAGE.ViewGroup.GroupPlaceholder}
          />
          <textarea
            type="text"
            className="color-white show-on-small-ress  color-groups-room-bg-highlight pdtxs"
            onChange={this.updateGroupSearchValue}
            value={this.props.currentMeetingRoomNameFilter}
            placeholder={APP.LANGUAGE.ViewGroup.GroupPlaceholderShort}
          />
          <i className="search link icon mrrs" />
        </div>
      );
    }

    return (
      <div>
        {modals}
        <div onMouseMove={this.mouseMovedOnTable} className="ui equal width center aligned padded grid">
          <div className="row flexible color-groups-bg pdtnull pdbnull header-row">
            <div className=" ui transparent large fluid icon input color-white first-column   column  display-flex  align-center-flex color-white hide-on-small-ress left-text align-center-flex">
              {textInputToDisplay}
            </div>
            <span className="ui transparent second-column pdlxs color-groups-bg large fluid icon input color-white  column  display-flex color-white hide-on-small-ress left-text">
              <span className="max-width pdxs hide-on-small-ress">
                {APP.LANGUAGE.ViewGroup.OrganisationPlaceholder}
              </span>
              <span className="max-width pdxs show-on-small-ress">
                {APP.LANGUAGE.ViewGroup.OrgUnitPlaceholderShort}
              </span>
            </span>
            <span className="ui pdlxs transparent color-groups-bg third-column large fluid icon input color-white  column  display-flex color-white hide-on-small-ress left-text">
              <span className="max-width pdxs ">{APP.LANGUAGE.ViewGroup.MembersPlaceholder}</span>
            </span>
          </div>
          {groups}
          {groupsGray}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFetchingGroup: state.groupsReducer.fetchingGroups,
    meetingRoomForm: state.meetingRoomReducer.meetingRoomForm,
  };
}
